import { NavSectionLabel } from '@strivelabs/ui-blocks/v2';
import type { WorkflowExecution } from '@/hooks/useWorkflowExecutions';
import { DATE_GROUP_LABELS, type DateGroup } from '@/utils/date';
import { ChatRow } from './ChatRow';

export interface ChatGroupProps {
  group: DateGroup;
  executions: WorkflowExecution[];
  activeExecutionId?: string;
  onRename: (execution: WorkflowExecution) => void;
  onDelete: (executionId: string) => void;
}

/**
 * One relative-date bucket: "Today", "Previous 7 days", and so on.
 *
 * Wears the nav tree's own section heading rather than a copy of it, so the
 * two tabs break their lists the same way. The nav's 15px indent is the caret
 * gutter's, which the chat list does not have — the list carries that offset
 * itself, so the heading sits at the rail's own 4px.
 */
export function ChatGroup({
  group,
  executions,
  activeExecutionId,
  onRename,
  onDelete,
}: ChatGroupProps) {
  return (
    <li>
      <NavSectionLabel label={DATE_GROUP_LABELS[group]} className="pl-1" />
      <ul className="flex flex-col">
        {executions.map(execution => (
          <ChatRow
            key={execution.id}
            execution={execution}
            isActive={String(execution.id) === activeExecutionId}
            onRename={() => onRename(execution)}
            onDelete={() => onDelete(String(execution.id))}
          />
        ))}
      </ul>
    </li>
  );
}
